/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ScanFrameTextIcon64Regular = forwardRef('ScanFrameTextIcon64Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 64 }, props),
        React.createElement("path", { d: "M48.5 7a8.5 8.5 0 0 1 8.5 8.5v6a1.5 1.5 0 0 1-3 0v-6a5.5 5.5 0 0 0-5.5-5.5h-6a1.5 1.5 0 0 1 0-3h6Z" }),
        React.createElement("path", { d: "M7 48.5a8.5 8.5 0 0 0 8.5 8.5h6a1.5 1.5 0 0 0 0-3h-6a5.5 5.5 0 0 1-5.5-5.5v-6a1.5 1.5 0 0 0-3 0v6Z" }),
        React.createElement("path", { d: "M57 48.5a8.5 8.5 0 0 1-8.5 8.5h-6a1.5 1.5 0 0 1 0-3h6a5.5 5.5 0 0 0 5.5-5.5v-6a1.5 1.5 0 0 1 3 0v6Z" }),
        React.createElement("path", { d: "M7 15.5A8.5 8.5 0 0 1 15.5 7h6a1.5 1.5 0 0 1 0 3h-6a5.5 5.5 0 0 0-5.5 5.5v6a1.5 1.5 0 0 1-3 0v-6Z" }),
        React.createElement("path", { d: "M19.5 39a1.5 1.5 0 0 0 0 3h13a1.5 1.5 0 0 0 0-3h-13Z" }),
        React.createElement("path", { d: "M18 31.5a1.5 1.5 0 0 1 1.5-1.5h25a1.5 1.5 0 0 1 0 3h-25a1.5 1.5 0 0 1-1.5-1.5Z" }),
        React.createElement("path", { d: "M19.5 21a1.5 1.5 0 0 0 0 3h25a1.5 1.5 0 0 0 0-3h-25Z" })));
});
